
import React from 'react'
import { Link } from 'react-router-dom'

interface AboutSplitV2Props {
  currentLang: 'zh' | 'en'
}

const AboutSplitV2: React.FC<AboutSplitV2Props> = ({ currentLang }) => {
  const t = currentLang === 'zh'
    ? {
        eyebrow: 'About',
        title: '從一顆豆子開始的故事',
        body1: '每一杯咖啡，都是一段未被書寫的故事。從生豆挑選、烘焙曲線、到沖煮細節，我們相信品味是值得被等待的。',
        body2: 'ONGU Studio 不只追求咖啡的好喝，更追求人與人在咖啡之間的相遇——讓每一次品飲，都成為日常裡值得停留的片刻。',
        cta: 'Read more',
      }
    : {
        eyebrow: 'About',
        title: 'A story that starts with a single bean',
        body1: 'Every cup is an untold story. From green-bean selection to roast curves to brewing precision, we believe taste is worth waiting for.',
        body2: 'At ONGU Studio, we pursue more than just great coffee — we craft moments where people meet over a quiet, considered cup.',
        cta: 'Read more',
      }

  return (
    <section className="bg-[#FAF9F1] py-20 md:py-28">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-10 px-6 md:grid-cols-2 md:gap-16 md:px-10 lg:px-16">
        {/* Left image — square ratio, baristamap style */}
        <div className="relative">
          <img
            src="https://file.lumi.new/p373839333138763776/SPF2016978764963844096.webp"
            alt={currentLang === 'zh' ? 'ONGU 焙煎所' : 'ONGU roastery'}
            className="aspect-square w-full object-cover"
          />
        </div>

        {/* Right text — left aligned, generous whitespace */}
        <div className="flex flex-col justify-center">
          <p
            className="mb-6 text-sm tracking-widest text-black/70"
            style={{ fontFamily: "'EB Garamond', serif", fontStyle: 'italic' }}
          >
            {t.eyebrow}
          </p>

          <h2
            className="mb-8 text-2xl text-black md:text-[28px]"
            style={{
              fontFamily: "'Noto Serif TC', 'EB Garamond', serif",
              fontWeight: 400,
              letterSpacing: '0.05em',
              lineHeight: 1.5,
            }}
          >
            {t.title}
          </h2>

          <p className="mb-5 text-[15px] leading-loose text-black/75" style={{ letterSpacing: '0.02em' }}>
            {t.body1}
          </p>
          <p className="mb-10 text-[15px] leading-loose text-black/75" style={{ letterSpacing: '0.02em' }}>
            {t.body2}
          </p>

          <Link
            to={`/${currentLang}/lab`}
            className="group inline-flex w-fit items-center text-sm tracking-widest text-black"
            style={{ fontFamily: "'EB Garamond', serif" }}
          >
            <span className="border-b border-black pb-1 transition-all duration-300 group-hover:tracking-[0.25em]">
              {t.cta}
            </span>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default AboutSplitV2
